import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import t from '../../service/translate.service'
import { Input } from '../../components/formComponents'
import { extendObservable } from 'mobx'
import AddressSelect from '../../components/AddressSelect'
import ThankYouOverlay from '../../components/ThankYouOverlay'
import LoadingPageOverlay from '../../components/LoadingPageOverlay'
import { Alert } from 'antd'
import { Form, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import User from '../../store/user.store'
import YouTube from 'react-youtube'
import withRouter from '../../components/withRouter'
import ContractVerificationPage from './ContractVerificationPage'
import { isEmpty } from 'lodash'
import * as dataPreserveService from '../../service/dataPreserve.service'
import { appFeatureEnabled } from '../../service/appFeatures.service'

class AddContract extends Component {
  static propTypes = {
    contractStore: PropTypes.object.isRequired,
    onboarding: PropTypes.bool,
    verificationError: PropTypes.string,
    contractNumber: PropTypes.string,
    address: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.props.contractStore.newContract()
    this.inputRefs = [
      React.createRef(),
      React.createRef()
    ]

    this.state = {
      inputs: {
        contractNumber: "",
        address: ""
      }
    }

    extendObservable(this, {
      submitSuccess: false,
      err: null,
      thankYouText: t.ADD_CONTRACT_THANK_YOU_TEXT,
      verificationEnabled: false,
      verificationStarted: false,
      isManual: false,
      submitted: false,
      errorsList: []
    })
  }

  generateErrorList = () => {
    const errors = []
    for (let i = 0; i < this.inputRefs.length; i++) {
      const inputRef = this?.inputRefs[i]?.current
      if (i === 0) {
        const val = inputRef?.value
        const label = inputRef?.ariaLabel
        const error = this.props.contractStore.alertValidators['contractNumber'](val, label)
        if (error) {
          errors.push(
            <button
              key={1}
              type='button'
              onClick={() => {
                inputRef.focus()
              }}
            >
              {error}
            </button>
          )
        }
      }

      if (i === 1) {
        const val = inputRef?.props?.value
        const label = inputRef?.props?.label
        const error = this.props.contractStore.alertValidators['address'](val, label)
        if (error) {
          errors.push(
            <button
              key={2}
              type='button'
              onClick={() => {
                inputRef.focus()
              }}
            >
              {error}
            </button>
          )
        }
      }
    }
    return errors
  }

  AlertContent = () => {
    const errorsList = this.errorsList
    const errorListVoice = this.props.contractStore.errorListVoice
    if (errorsList?.length > 0) {
      window.scrollTo(0, 0)
      return (
        <Alert
          role={errorListVoice ? "alert" : "none"}
          message={
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          }
          type='error'
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )
    } else {
      return (<></>)
    }
  }

  componentDidMount = () => {
    const data = dataPreserveService.getData('contract')

    if (data) {
      this.setState((prevState) => ({
        inputs: {
          ...prevState.inputs,
          contractNumber: data.contractNumber,
          address: data.address
        }
      }))

      dataPreserveService.removeData('contract')
    }

    ;(async() => {
      const verificationEnabled = appFeatureEnabled('verificationEnabled')
      if(verificationEnabled) this.verificationEnabled = true
    })()
  }
  
  onSubmit = e => {
    this.errorsList = []
    this.errorsList = this.generateErrorList()
    this.props.contractStore.errorListVoice = true
    if(e) e.preventDefault()
    this.props.contractStore
      .submitContract()
      .then((res) => {
        if (res !== 'err') {
          this.thankYouText = t.ADD_CONTRACT_THANK_YOU_TEXT
          this.submitSuccess = true
        }
      })
      .catch(err => {
        this.err = err
        dataPreserveService.saveData('contract', {
          contractNumber: this.state.inputs.contractNumber,
          address: this.props.contractStore.contract.address
        })
      })
  }

  onManualSubmit = e => {
    this.errorsList = []
    this.errorsList = this.generateErrorList()
    this.props.contractStore.errorListVoice = true
    e.preventDefault()
    this.props.contractStore
      .submitContract(true)
      .then((res) => {
        if (res !== 'err') {
          this.thankYouText = t.ADD_CONTRACT_MANUAL_THANK_YOU_TEXT
          this.submitSuccess = true
          this.props.contractStore.newContract()
          this.err = null
          this.addressSelectRef = null
        }
      })
      .catch(err => {
        console.log(err)
        this.err = err
      })
  }

  handleBack = (e) => {
    this.props.menuStore.setCurrentPage('/')
    this.props.navigate('/')
  }
  handleCancel = () => {
    this.props.navigate('/')
  }

  isTenant = () => {
    return User?.user?.tenant
  }

   handleOk = () => {
    this.props.contractStore.verificationModalOpen = false
  };

  startVerification = async (e) => {
    this.errorsList = []
    this.errorsList = this.generateErrorList()
    this.props.contractStore.errorListVoice = true
    e.preventDefault()
    const { contractStore } = this.props;
    contractStore.setSubmit(true)
    const { contractNumber, address } = contractStore.contract;
  
    if(isEmpty(contractNumber)) return
    if(isEmpty(address)) return
    if(!this.testContractFormat(contractNumber)) return
    
    const contractVerified = await contractStore.getContractVerificationInfo(contractNumber)
    const contractExists = await contractStore.getSAPContractDetails(contractNumber).catch((err) => {
      this.isManual = true
    })
    contractStore.setSubmit(false)
    if(contractVerified) return this.onSubmit()
    if(contractExists) this.verificationStarted = true
    else  {
      contractStore.error = t['INVALID_CONTRACT']
     this.isManual = true
     return
    } 
  }

   testContractFormat = (value) => {
    const regex = /^(\d+)\/MV\w+$|^W\w+\/W\w+-\w+-\w{2}$/;
    return regex.test(value);
  }

  handleOnInputChange = (e) => {
    let val = e.target.value
    val = val.replace(/[\s]/g, '');

    this.setState((prevState) => ({
      inputs: {
        ...prevState.inputs,
        contractNumber: val
      }
    }))

    this.props.contractStore.setVal('contractNumber', val)
  }

  render() {
    const { contractStore, onboarding, verificationError, contractNumber, address } = this.props
    if(address) contractStore.contract.address = address
    const loading = contractStore.creatingContract
    if(this.err && this.err.message !== 'CONTRACT_EXISTS') {
      this.isManual = true
    }

    if(contractNumber) {
      contractStore.contract.contractNumber = contractNumber
      this.isManual = true
    } 
    const istenant = this.isTenant()
    const youtubeOptions = {
      height: '250',
      width: '400'
    }
    return (
      <div className="subpageContent">
        {this.submitSuccess ? (
          <ThankYouOverlay
            title={t.THANK_YOU}
            description={this.thankYouText}
            buttonText={t.BACK_HOME}
            buttonLink="/"
            handleClick={this.handleOk}
            aria-live="polite"
          />
        ) : (
          <div>
            {verificationError && verificationError.length && (
              <Alert
                message={verificationError}
                type="error"
                role='alert'
                style={{ marginBottom: "12px", marginTop: "12px" }}
                aria-live="assertive"
              />
            )}
            <div className="title" aria-live="polite">{t.ADD_A_CONTRACT_BUTTON}</div>
            <div className="subtitle">{t.ADD_CONTRACT_SUBTITLE}</div>
            {contractStore?.error && (
              <Alert
                message={this?.props?.contractStore?.error}
                type="error"
                style={{ marginBottom: "12px", marginTop: "12px" }}
                aria-live="assertive"
                role='alert'
              />
            )}
            {this.verificationStarted && (
              <ContractVerificationPage isAddingContract={true} />
            )}
            {this.submitted&& (
              <this.AlertContent />
            )}
            <Form>
                <Input
                  name='contractNumber'
                  label={t['USER_TENANT_NUMBER']}
                  required={true}
                  ref={this.inputRefs[0]}
                  type='text'
                  onChange={this.handleOnInputChange}
                  value={this.state.inputs.contractNumber}
                  helper={<span>{t.CONTRACT_INFO}</span>}
                  validate={contractStore.validators.contractNumber}
                  blurValidate={contractStore.alertValidators.contractNumber}
                  aria-describedby="contract-number-helper"
                />
                <AddressSelect
                  label={t.USER_ADDRESS}
                  onChange={address => contractStore.setVal('address', address)}
                  ref={this.inputRefs[1]}
                  value={this.state.inputs.address || contractStore.contract.address}
                  validate={contractStore.validators.address(
                    contractStore.contract.address,
                    t['USER_ADDRESS']
                  )}
                  blurValidate={contractStore.alertValidators.address(
                    contractStore.contract.address,
                    t['USER_ADDRESS']
                  )}
                  aria-describedby="address-helper"
                  required={true}
                />
              <Form.Group className='actions text-center'>
                {<button
                  onClick={(e) => {
                    this.submitted = false
                    if (this.verificationEnabled) {
                      this.startVerification(e)
                    } else {
                      this.onSubmit(e)
                    }
                    setTimeout(() => {
                      this.submitted = true
                    }, 100)
                  }}
                  className='button primary'
                  aria-label={this.isManual ? t.ADD_CONTRACT_AGAIN : t.ADD_CONTRACT_BUTTON}
                >
                  {this.isManual ? t.ADD_CONTRACT_AGAIN : t.ADD_CONTRACT_BUTTON}
                </button>}
                {this.isManual && (
                  <button
                    type='submit'
                    className='button primary'
                    onClick={this.onManualSubmit}
                    aria-label={t.MANUAL_APPROVAL_SUBMIT}
                  >
                    {t.MANUAL_APPROVAL_SUBMIT}
                  </button>)}
                {onboarding && (<button
                  className='button secondary'
                  onClick={this.handleCancel}
                  aria-label={t.DO_THIS_LATER_BUTTON}
                >
                  {t.DO_THIS_LATER_BUTTON}
                </button>)}
              </Form.Group>
            </Form>
            {onboarding && istenant && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <YouTube
                  videoId="oHoag5w9Awc"
                  opts={youtubeOptions}
                  aria-label={t.ONBOARDING_VIDEO}
                />
              </div>
            )}
            {loading && <LoadingPageOverlay />}
          </div>
        )}
      </div>
    );
  }
}

AddContract.propTypes = {
  menuStore: PropTypes.object
}
export default inject('contractStore', 'menuStore')(withRouter(observer(AddContract)))
